<template>
    <div class="flex items-center pt-5 pl-5 pr-5 text-white pb-7 bg-secondary">
        <div class="flex flex-grow space-x-6">
            <div class="max-w-[43px]"><img :src="asset('img/logo-icon.svg')" class="h-auto max-w-full" alt="Mammoth"></div>
            <div class="hidden">
                <div class="bg-[#323A48] space-x-[10px] pl-4 flex rounded-md lg:w-[416px] items-center">
                    <div class="">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.29583 11.5892 8.49572 10.8907 9.47653L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L9.47653 10.8907C8.49572 11.5892 7.29583 12 6 12C2.68629 12 0 9.31371 0 6Z" fill="white"/>
                        </svg>
                    </div>
                    <input type="text" class="bg-[#323A48] text-white text-sm w-full border-0 border-transparent placeholder-white focus:outline-none focus:ring-0 focus:border-transparent focus:border-0" placeholder="Search">
                </div>
            </div>
        </div>
        <div class="flex items-center space-x-[30px]">
            <div class="">
                <a href="#" class="inline-flex">
                    <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 15.5H17L15.5951 14.0951C15.2141 13.7141 15 13.1973 15 12.6585V9.5C15 6.88757 13.3304 4.66509 11 3.84142V3.5C11 2.39543 10.1046 1.5 9 1.5C7.89543 1.5 7 2.39543 7 3.5V3.84142C4.66962 4.66509 3 6.88757 3 9.5V12.6585C3 13.1973 2.78595 13.7141 2.40493 14.0951L1 15.5H6M12 15.5V16.5C12 18.1569 10.6569 19.5 9 19.5C7.34315 19.5 6 18.1569 6 16.5V15.5M12 15.5H6" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </a>
            </div>
            <div class="relative">
                <app-dropdown wrapper-classes="!mt-1">
                    <template #trigger>
                        <img :src="avatar" class="w-[42px] h-[42px] rounded-full cursor-pointer">
                    </template>

                    <template #content>
                        <dropdown-link :href="route('profile')">Account Settings</dropdown-link>
                        <dropdown-link :href="route('logout')">Logout</dropdown-link>
                    </template>
                </app-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
import AppDropdown from '@Components/Dropdown.vue'
import DropdownLink from '@Components/DropdownLink.vue'

export default {
    components: {
        AppDropdown,
        DropdownLink
    },
    computed: {
        avatar(){
            const firstName = _.get(this.$page.props, 'auth.user.first_name')
            const lastName = _.get(this.$page.props, 'auth.user.last_name')
            const fullName = firstName + ' ' + lastName

            return `https://ui-avatars.com/api/?name=${encodeURI(fullName)}&color=FFFFFF&background=57808B`
        }
    }
}
</script>

<style>

</style>
